import { Menu } from "@mui/icons-material";
import { AppBar, Box, Button, Container, IconButton, Toolbar, useMediaQuery } from "@mui/material";
import { ElevationScroll } from "layouts/common";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLanguage } from "store/languageSlice";

export default function LandingAppBar() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { language } = useSelector(state => state?.lang)
    const { isAuth } = useSelector(state => state?.auth)
    const { t } = useTranslation()
    const lessThanSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    const changeLanguage = () => {
        let target = language === "ar-SA" ? "en-US" : "ar-SA"
        dispatch(setLanguage({ language: target }))
    }

    return (
        <ElevationScroll>
            <AppBar sx={{ backgroundColor: "white" }}>
                <Container>
                    <Toolbar>
                        {lessThanSmall
                            &&
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                sx={{ mr: 2 }}
                            >
                                <Menu />
                            </IconButton>
                        }
                        <Box display="flex" justifyContent="space-between" alignItems="center" flexGrow={1}>
                            <img onClick={()=>navigate("/")} src="/images/Logo.png" height={50} alt="logo" />
                            <Box>
                                {isAuth ?
                                    <Button
                                        onClick={() => navigate("/admin")}
                                        sx={{
                                            mr: 15,
                                            fontSize: 14,
                                            fontWeight: "bold",
                                            textTransform: 'none',
                                            '&:hover': {
                                                color: "secondary.main",
                                            },
                                        }}>
                                        {t("Dashboard")}
                                    </Button>
                                    :
                                    <Button
                                        onClick={() => navigate("/auth/login")}
                                        sx={{
                                            mr: 15,
                                            fontSize: 14,
                                            fontWeight: "bold",
                                            textTransform: 'none',
                                            '&:hover': {
                                                color: "secondary.main",
                                            },
                                        }}>
                                        {t("Login")}
                                    </Button>
                                }
                                <Button
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        textTransform: 'none',
                                        '&:hover': {
                                            color: "secondary.main",
                                        },
                                    }}
                                    onClick={() => changeLanguage()}>
                                    {t("العربية")}
                                </Button>
                            </Box>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </ElevationScroll>
    )
}